import { useState, type InputHTMLAttributes } from 'react';

type PasswordInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

/**
 * A password field with a Show / Hide button (the eye) at its right edge. Takes the same props as
 * an <input>; the field keeps its own className (the button sits over its last 40px, so inputs
 * here are 40px tall, h-10).
 */
export default function PasswordInput({ className = '', ...props }: PasswordInputProps) {
  const [visible, setVisible] = useState(false);
  return (
    <span className="relative block">
      <input {...props} type={visible ? 'text' : 'password'} className={`${className} pr-10`} />
      <button
        type="button"
        onClick={() => setVisible((shown) => !shown)}
        aria-label={visible ? 'Hide password' : 'Show password'}
        aria-pressed={visible}
        title={visible ? 'Hide password' : 'Show password'}
        className="absolute bottom-0 right-0 flex h-10 w-10 items-center justify-center rounded-md text-foreground-500 hover:text-foreground-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400"
      >
        <i className={visible ? 'ri-eye-off-line' : 'ri-eye-line'} aria-hidden="true" />
      </button>
    </span>
  );
}
